import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Toast, Dialog } from 'antd-mobile';
import request from 'src/utils/request';
import './style/loginStyle.scss';
import Logo from 'src/assets/images/LOGO.png';

export default function Login() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [forgetForm] = Form.useForm();
    const [countdown, setCountdown] = useState(0);

    const handleLogin = async (values) => {
        setLoading(true);

        const response = await request.post('/public/User/LoginClient', {
            userName: values.userName,
            password: values.password
        });

        // 保存用户信息到 localStorage
        if (response.ok && response.data) {
            localStorage.setItem('userInfo', JSON.stringify(response.data));
            localStorage.setItem('token', response.data.token.token || '');
            Toast.show({
                icon: 'success',
                content: '登录成功',
                duration: 1500,
            });

            // 延迟跳转到首页
            setTimeout(() => {
                navigate('/home');
            }, 500);
        } else {
            Toast.show({
                icon: 'fail',
                content: response.msg,
                duration: 1500,
            })
        }
        setLoading(false);
    };

    // 发送验证码
    const handleSendCode = async (phone) => {
        if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
            Toast.show('请先输入有效的手机号');
            return;
        }

        try {
            const response = await request.post('/public/User/Sms', { phone });
            if (response && response.ok) {
                Toast.show('验证码已发送');
                setCountdown(60);
                const timer = setInterval(() => {
                    setCountdown(prev => {
                        if (prev <= 1) {
                            clearInterval(timer);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            } else {
                Toast.show(response?.msg || '发送失败');
            }
        } catch (error) {
            Toast.show('发送失败，请重试');
        }
    };

    // 忘记密码
    const handleForgetPassword = () => {
        Dialog.show({
            title: '忘记密码',
            content: (
                <div className="forget-password-dialog">
                    <Form
                        form={forgetForm}
                        layout='vertical'
                    >
                        <Form.Item
                            name='phone'
                            label='手机号'
                            rules={[
                                { required: true, message: '请输入手机号' },
                                { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号' }
                            ]}
                        >
                            <Input
                                placeholder='请输入手机号'
                                clearable
                                className="forget-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name='code'
                            label='验证码'
                            rules={[{ required: true, message: '请输入验证码' }]}
                        >
                            <div className="code-input-wrapper">
                                <Input
                                    placeholder='请输入验证码'
                                    clearable
                                    className="forget-input"
                                />
                                <Button
                                    className="code-btn"
                                    disabled={countdown > 0}
                                    onClick={() => {
                                        const phone = forgetForm.getFieldValue('phone');
                                        handleSendCode(phone);
                                    }}
                                >
                                    {countdown > 0 ? `${countdown}秒` : '获取验证码'}
                                </Button>
                            </div>
                        </Form.Item>
                        <Form.Item
                            name='passWordNew'
                            label='新密码'
                            rules={[
                                { required: true, message: '请输入新密码' },
                                { min: 6, message: '密码至少6位' }
                            ]}
                        >
                            <Input
                                type='password'
                                placeholder='请输入新密码'
                                clearable
                                className="forget-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name='confirmPassword'
                            label='确认密码'
                            rules={[
                                { required: true, message: '请确认新密码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('passWordNew') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('两次输入的密码不一致'));
                                    },
                                }),
                            ]}
                        >
                            <Input
                                type='password'
                                placeholder='请确认新密码'
                                clearable
                                className="forget-input"
                            />
                        </Form.Item>
                    </Form>
                </div>
            ),
            closeOnAction: true,
            actions: [
                {
                    key: 'cancel',
                    text: '取消',
                    className: 'dialog-cancel-btn'
                },
                {
                    key: 'confirm',
                    text: '确定',
                    primary: true,
                    className: 'dialog-confirm-btn',
                    onClick: async () => {
                        try {
                            const values = await forgetForm.validateFields();

                            Toast.show({
                                icon: 'loading',
                                content: '处理中...',
                                duration: 0
                            });

                            const response = await request.post('/public/User/ForgetPassWord', {
                                phone: values.phone,
                                code: values.code,
                                passWordNew: values.passWordNew
                            });

                            Toast.clear();

                            if (response && response.ok) {
                                Toast.show({
                                    icon: 'success',
                                    content: '密码重置成功，请登录'
                                });
                                forgetForm.resetFields();
                            } else {
                                Toast.show({
                                    icon: 'fail',
                                    content: response?.msg || '重置失败'
                                });
                            }
                        } catch (error) {
                            Toast.clear();
                            console.error('密码重置失败:', error);
                        }
                    }
                }
            ]
        });
    };


    return (
        <div className='login-container'>
            <div className="login-logo-section">
                <div className="logo-img">
                    <img src={Logo} alt="Logo" onError={(e) => {
                        e.target.style.display = 'none';
                    }} />
                </div>
                <div className="app-name">猪场交易平台</div>
                <div className="app-slogan">专业的畜牧养殖交易服务</div>
            </div>

            <div className="login-form-card">
                <div className="form-title">账号登录</div>

                <Form
                    form={form}
                    onFinish={handleLogin}
                    footer={
                        <div className="login-btn">
                            <Button
                                block
                                type='submit'
                                color='primary'
                                size='large'
                                loading={loading}
                                disabled={loading}
                            >
                                {loading ? '登录中...' : '登录'}
                            </Button>
                        </div>
                    }
                >
                    <Form.Item
                        name='userName'
                        rules={[
                            { required: true, message: '请输入用户名' },
                        ]}
                    >
                        <Input
                            placeholder='请输入用户名'
                            clearable
                            prefix={
                                <div className="input-prefix">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor" />
                                    </svg>
                                </div>
                            }
                        />
                    </Form.Item>

                    <Form.Item
                        name='password'
                        rules={[
                            { required: true, message: '请输入密码' },
                        ]}
                    >
                        <Input
                            placeholder='请输入密码'
                            clearable
                            type='password'
                            prefix={
                                <div className="input-prefix">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" fill="currentColor" />
                                    </svg>
                                </div>
                            }
                        />
                    </Form.Item>
                </Form>

                <div className="form-footer" >
                    <span className="forgot-password" onClick={handleForgetPassword}>
                        忘记密码？
                    </span>
                    <span className="register-link" onClick={() => navigate('/register')}>
                        注册账号
                    </span>
                </div>
            </div>

            <div className="login-footer">
                版权所有 © 2026 旭瑞集团
            </div>
        </div>
    );
}
